import React from "react" ;

/**
 * Specification of props for the rect drawer
 */
export type CanvasThrobberRectProps = {
    /**
     * The x-coordinate of the top-left corner
     */
    x: number;

    /**
     * The y-coordinate of the top-left corner
     */
    y: number;

    /**
     * The width of the rectangle
     */
    w: number;

    /**
     * The height of the rectangle
     */
    h: number;

    /**
     * A delay before the rendering of the rectangle begins, defined in percent
     * of the total drawing.
     */
    delay?: number;

    /**
     * The duration of the drawing of the rectangle, defined in percent of the
     * total drawing duration.
     */
    duration: number;

    /**
     * If you want multiple shapes to use the same easing-curve, then make sure
     * that they are given the same ease-name. This is useful if for instance
     * you are drawing two shapes that are part of the same visual entity.
     */
    ease?: string;
};

/**
 * This component is used to configure drawing of a rectangle inside a
 * [[CanvasThrobber]].
 */
// tslint:disable-next-line variable-name
export const CanvasThrobberRect: React.FC<CanvasThrobberRectProps> = () => null;

/**
 * Type specification of the arc, so that we can safely identify it even if
 * react-hot-loader was used.
 */
export const typeOfCanvasThrobberRect = (<CanvasThrobberRect x={0} y={0} w={0} h={0} duration={0} />).type;
